import React, {useState} from "react";
import s from "./Account.module.css";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {getAuth, sendPasswordResetEmail} from "firebase/auth";


const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [formError, setFormError] = useState(null);
    const [isReset, setIsReset] = useState(false);

    const handleSubmit = async (e, email) => {
        e.preventDefault();
        const auth = getAuth();
        sendPasswordResetEmail(auth, email)
            .then(() => {
                setFormError(null);
                setIsReset(true);
                setEmail("");
            })
            .catch((error) => {
                setFormError(error.message);
            });
    }

    return (
        <div>
            <h3>Забыли пароль?</h3>
            <p>Введите E-Mail Вашей учетной записи. Нажмите кнопку Вперед, чтобы получить пароль по электронной почте.
            </p>
            <form onSubmit={(e) => handleSubmit(e, email)} className={s.resetPassword}>
                <div>
                    <h5>E-Mail:</h5>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} type="email"
                           placeholder="example@gmail.com"/>
                </div>
                {formError ? <p>{formError}</p> : null}
                <BuyButton>Продолжить</BuyButton>
                {isReset ? <h3>Письмо отправлено на почту</h3> : null}
            </form>
        </div>
    )
}

export default ResetPassword;